// @ts-nocheck

const getVarsFromUrl = <T extends { [name: string]: string }>(url: string = null): T => {
    const locUrl = new URL(url ? url : document.location.href);
    return (locUrl.search
        .replace(/(^\?)/, '')
        .split('&')
        .filter((v) => v)
        .map(
            function (n) {
                return (n = n.split('=')), (this[n[0]] = n[1]), this;
            }.bind({})
        )[0] as T) || ({} as T);
};

export default getVarsFromUrl;
